import * as React from 'react';
import { RouteComponentProps, NavLink } from 'react-router-dom';

export interface StateFromProps {
    hasDirtyData: boolean;
}

export interface ParentProps {
    to: string;
    id?: string;
}

interface State {}

export type OwnProps = RouteComponentProps<{ }> & ParentProps;

type Props = StateFromProps & OwnProps;

class NavItem extends React.Component<Props, State> {
    liItem: HTMLLIElement;
    constructor(props: Props) {
        super(props);
    }

    render() {
        const { id, to, children } = this.props;

        return (
            <li
                ref={(li: HTMLLIElement) => { this.liItem = li; }}
                className="nav-item"
            >
                <NavLink
                    className="nav-link"
                    activeClassName="active"
                    data-scroll={true}
                    role="tab"
                    to={to}
                    {...id ? { id: id } : {}}
                >
                    {children}
                </NavLink>
            </li>
        );
    }
}

export default NavItem;


// WEBPACK FOOTER //
// ./src/components/shared/NavItem/NavItem.tsx